var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#a171eb"
    },
    points: "179.2,320 332.8,166.4 435.2,166.4 281.6,320 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#a171eb"
    },
    points: "384,320 499.2,204.8 499.2,320 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d7bdff"
    },
    points: "281.6,320 435.2,166.4 499.2,166.4 499.2,204.8 384,320 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d7bdff"
    },
    points: "12.8,166.4 128,166.4 12.8,281.6 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#d7bdff"
    },
    points: "76.8,320 230.4,166.4 332.8,166.4 179.2,320 "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#a171eb"
    },
    points: "12.8,320 12.8,281.6 128,166.4 230.4,166.4 76.8,320 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a171eb"
    },
    d: "M409.6,115.2c-21.171,0-38.4-17.229-38.4-38.4s17.229-38.4,38.4-38.4 c21.171,0,38.4,17.229,38.4,38.4S430.771,115.2,409.6,115.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a171eb"
    },
    d: "M102.4,115.2C81.229,115.2,64,97.971,64,76.8s17.229-38.4,38.4-38.4s38.4,17.229,38.4,38.4 S123.571,115.2,102.4,115.2z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a171eb"
    },
    d: "M486.4,153.6h-64v-27.409c22.042-5.709,38.4-25.557,38.4-49.391c0-28.279-22.921-51.2-51.2-51.2 c-28.279,0-51.2,22.921-51.2,51.2c0,23.834,16.358,43.682,38.4,49.391V153.6H115.2v-27.409c22.042-5.709,38.4-25.557,38.4-49.391 c0-28.279-22.921-51.2-51.2-51.2S51.2,48.521,51.2,76.8c0,23.834,16.358,43.682,38.4,49.391V153.6h-64C11.46,153.6,0,165.06,0,179.2 v128c0,14.14,11.46,25.6,25.6,25.6h64v128H64c-7.074,0-12.8,5.726-12.8,12.8c0,7.074,5.726,12.8,12.8,12.8h76.8 c7.074,0,12.8-5.726,12.8-12.8c0-7.074-5.726-12.8-12.8-12.8h-25.6v-128h281.6v128h-25.6c-7.074,0-12.8,5.726-12.8,12.8 c0,7.074,5.726,12.8,12.8,12.8H448c7.074,0,12.8-5.726,12.8-12.8c0-7.074-5.726-12.8-12.8-12.8h-25.6v-128h64 c14.14,0,25.6-11.46,25.6-25.6v-128C512,165.06,500.54,153.6,486.4,153.6z M384,76.8c0-14.114,11.486-25.6,25.6-25.6 c14.114,0,25.6,11.486,25.6,25.6s-11.486,25.6-25.6,25.6C395.486,102.4,384,90.914,384,76.8z M76.8,76.8 c0-14.114,11.486-25.6,25.6-25.6S128,62.686,128,76.8s-11.486,25.6-25.6,25.6S76.8,90.914,76.8,76.8z M25.6,179.2h71.501 L25.6,250.701V179.2z M71.501,307.2H25.6v-20.301L133.299,179.2h66.202L71.501,307.2z M107.699,307.2l128-128h66.202l-128,128 H107.699z M210.099,307.2l128-128h66.202l-128,128H210.099z M486.4,307.2h-71.501l71.501-71.501V307.2z M486.4,199.501 L378.701,307.2h-66.202l128-128H486.4V199.501z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenance);
export default __webpack_public_path__ + "static/media/Maintenance.49f880c9c96d5e22bf855faf9689d05b.svg";
export { ForwardRef as ReactComponent };